import { call, put, SagaReturnType, takeLatest } from 'redux-saga/effects';
import { SigningPinConstants } from 'src/redux/actions/constant';
import signingPinService from 'src/services/apiServices/signing-pin-service/signing-pin-service';

const {
  GET_SIGNING_PIN_STATUS_REQUEST,
  GET_SIGNING_PIN_STATUS_SUCCESS,
  GET_SIGNING_PIN_STATUS_FAILURE,
  GET_SIGNING_PIN_STATUS_LOADING,
  SETUP_SIGNING_PIN_REQUEST,
  SETUP_SIGNING_PIN_SUCCESS,
  SETUP_SIGNING_PIN_FAILURE,
  SETUP_SIGNING_PIN_LOADING,
  RESET_SIGNING_PIN_REQUEST,
  RESET_SIGNING_PIN_SUCCESS,
  RESET_SIGNING_PIN_FAILURE,
  RESET_SIGNING_PIN_LOADING,
} = SigningPinConstants;

export function* getSigningPinStatus(): SagaReturnType<any> {
  try {
    yield put({ type: GET_SIGNING_PIN_STATUS_LOADING });
    const response = yield call(signingPinService.getStatus);
    if (response?.status === 200) {
      yield put({ type: GET_SIGNING_PIN_STATUS_SUCCESS, payload: response.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: GET_SIGNING_PIN_STATUS_FAILURE, payload: error });
  }
}

export function* setupSigningPin(action: any): SagaReturnType<any> {
  try {
    yield put({ type: SETUP_SIGNING_PIN_LOADING });
    const response = yield call(signingPinService.setupPin, action.payload);
    if (response?.status === 200) {
      yield put({ type: SETUP_SIGNING_PIN_SUCCESS, payload: response.data });
      //  Refresh hasPin so the UI reflects the new PIN immediately.
      yield put({ type: GET_SIGNING_PIN_STATUS_REQUEST });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: SETUP_SIGNING_PIN_FAILURE, payload: error });
  }
}

export function* resetSigningPin(action: any): SagaReturnType<any> {
  try {
    yield put({ type: RESET_SIGNING_PIN_LOADING });
    //  APIT-656: payload is { newPin, accountPassword } — the password gates the reset server-side.
    const response = yield call(
      signingPinService.resetPin,
      action.payload?.newPin,
      action.payload?.accountPassword
    );
    if (response?.status === 200) {
      yield put({ type: RESET_SIGNING_PIN_SUCCESS, payload: response.data });
      yield put({ type: GET_SIGNING_PIN_STATUS_REQUEST });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: RESET_SIGNING_PIN_FAILURE, payload: error });
  }
}

function* signingPinSaga() {
  yield takeLatest(GET_SIGNING_PIN_STATUS_REQUEST, getSigningPinStatus);
  yield takeLatest(SETUP_SIGNING_PIN_REQUEST, setupSigningPin);
  yield takeLatest(RESET_SIGNING_PIN_REQUEST, resetSigningPin);
}

export default signingPinSaga;
